import { rem } from 'polished';
import styled from 'styled-components';
import { BodyText, Button, HeadingText } from '@unmind/design-system';
import { DurationLabel as BaseDurationLabel } from '../DurationLabel';

export const Container = styled.div``;

export const DurationLabelContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${rem(24)};
`;

export const DurationLabel = styled(BaseDurationLabel)`
  margin-bottom: ${rem(24)};
`;

/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
export const Subheader = styled(HeadingText).attrs(({ theme }) => ({
  level: 3,
  sizes: [theme.typography.fontSizes.fontSize16],
  weight: theme.typography.fontWeights.bold,
}))`
  margin-bottom: ${rem(12)};
` as any;
/* eslint-enable @typescript-eslint/no-explicit-any */

export const Description = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize14],
}))`
  margin-bottom: ${rem(24)};
`;

export const BrowseButton = styled(Button)`
  width: 100%;
`;
